import PropTypes from 'prop-types';

const rootContext = {
  store: PropTypes.object.isRequired,
};

const childContext = {
  store: PropTypes.object.isRequired,
  theme: PropTypes.string,
  deviceInfo: PropTypes.object,
};

const themeContext = {
  theme: PropTypes.string,
};

const deviceInfoContext = {
  deviceInfo: PropTypes.object,
};

function getTheme(props, context) {
  if (props.theme) {
    return props.theme;
  }

  if (context.theme) {
    return context.theme;
  }

  if (props.route && props.route.theme) {
    return props.route.theme;
  }

  return undefined;
}

function getRootChildContext(props, context) {
  return {
    store: props.store || context.store,
    theme: getTheme(props, context),
    deviceInfo: props.deviceInfo || context.deviceInfo,
  };
}

export default {
  childContext,
  rootContext,
  getRootChildContext,
  themeContext,
  deviceInfoContext,
};
